import axios, { AxiosRequestConfig } from 'axios'
import {
  api_picking_lists_path,
  submit_api_picking_lists_path,
} from '../routes'
import { PickingListRowShape, PickingListSubmitResult, StagedPick } from './api_data_types'

export type CreatePickingListLinePayload = {
  job_id: string
  item_id?: number
  date: string
  quantity: string | number
}

export type CreatePickingListLineResponse = {
  status: string
  message: string
  data: { success: boolean }
}

type SubmitPickingListPicksPayload = {
  job_id: string
  picks: Array<{
    item_no: string
    item_id: StagedPick['item_id']
    quantity: StagedPick['quantity']
  }>
}

export function getPickingListsByJobId(jobId: string): Promise<PickingListRowShape[]> {
  const options: AxiosRequestConfig = {
    url: api_picking_lists_path({ format: 'json', job_id: jobId }),
    method: 'get',
    responseType: 'json',
  }
  return axios(options).then(response => response.data)
}

export function createPickingListLine(payload: CreatePickingListLinePayload): Promise<CreatePickingListLineResponse> {
  const options: AxiosRequestConfig = {
    url: api_picking_lists_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data)
}

export function submitPickingListPicks(payload: SubmitPickingListPicksPayload): Promise<PickingListSubmitResult> {
  const options: AxiosRequestConfig = {
    url: submit_api_picking_lists_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data.data)
}
